import React, { useState, useEffect } from 'react';
import { bool } from 'prop-types';
import { WithPermissions } from 'react-admin';
import FormWrapper from '../../common/ui/FormWrapper';
import FormContainer from './FormContainer';
import { UiCreateEditWrapper } from '../../common/ui/NewDesign/CreateEditWrapper';
import { getSalesOrderById } from '../../../api/salesOrders';

const SalesOrders = ({ isEdit, initialValues, ...rest }) => (
  <WithPermissions
    {...rest}
    render={({ permissions }) => (
      <FormWrapper>
        <UiCreateEditWrapper isEdit={isEdit} {...rest}>
          <FormContainer
            permissions={permissions}
            isEdit={isEdit}
            initialValues={initialValues}
            redirect={basePath => `${basePath}?submitted=true`}
          />
        </UiCreateEditWrapper>
      </FormWrapper>
    )}
  />
);


// export const SalesOrdersCreate = props => <SalesOrders {...props} />;
export const SalesOrdersEdit = props => <SalesOrders {...props} isEdit />;
export const SalesOrdersCreate = props => {
  const cloneId = localStorage.getItem("cloneId");
  const [defaultData, setDefaultData] = useState(null);

  useEffect(() => {
    if (cloneId) {
      getSalesOrderById(cloneId).then(orderData => {
        const order = orderData;
        const cleanedOrder = {
          ...order,
          id: undefined,
          saleOrderItems: (order.saleOrderItems || []).map(item => ({
            ...item,
            id: undefined,          // remove item ID
            saleOrderId: undefined, // remove reference to old order
            packTypeId: item.packType ? item.packType.id : item.packTypeId,
            packType: undefined,
            productId: item.productId,
            pricePerUnit: item.pricePerUnit,
            discPricePerUnit: item.discPricePerUnit,
            quantity: item.quantity,
          }))
        };

        // Flatten top-level nested objects (e.g. currency)
        if (orderData.currency.id) {
          cleanedOrder.currencyId = orderData.currency.id;
        }
        cleanedOrder.currency = undefined;
        setDefaultData(cleanedOrder);
      });
    }
  }, [cloneId]);


  if (cloneId && !defaultData) return <div>Loading...</div>;

  return <SalesOrders {...props} initialValues={defaultData} />;
};

SalesOrders.propTypes = {
  isEdit: bool,
};
